import React from 'react';

import { Helpers } from '../../core/src/helpers';

export default ({ html, className }) => {
    return <div className={'udf' + className} dangerouslySetInnerHTML={Helpers.createMarkup(html)} />;
};
